import i18n from "i18next";
import XeesterUser from "./User";

export default function userReducer(user, action) {
  //console.log("user", user);
  //console.log("action", action);
  switch (action.type) {
    case "update":
      return action.payload;
    case "disconnect": {
      document.location.href = "/opencards/" + i18n.language + "/home";
      return { error: 401 };
    }
    case "canvas": {
      let _user = XeesterUser.from(user);
      _user.canvas = action.payload;
      return _user;
    }
    case "avatar": {
      let _user = XeesterUser.from(user);
      _user.avatar = action.payload;
      return _user;
    }
    default:
      return user;
  }
}
